<div class="content">
    <ng-content></ng-content>
</div>
<hum-icon *ngIf="icon" [active]="true" [size]="'16'" [icon]="icon"></hum-icon>